import mediaQueries from 'syf-component-library/const/mediaQueries';
import useMedia from 'syf-js-utilities/hooks/useMedia';
var useDeviceWidth = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.query, query = _c === void 0 ? mediaQueries.lessThanSmall : _c;
    return useMedia([query], [true], false);
};
export default useDeviceWidth;
